export default __webpack_public_path__ + "static/hero-125133ce333cdb43761de5aaefcdf2d5.png";